import { useState, useEffect } from 'react';

interface Props {
  polledAt: number | null;
  isHoliday?: boolean | null;
}

function formatRelativeTime(timestamp: number): string {
  const diffMs = Math.max(0, Date.now() - timestamp);
  const diffSecs = Math.floor(diffMs / 1000);
  const diffMins = Math.floor(diffSecs / 60);
  const diffHours = Math.floor(diffMins / 60);
  const diffDays = Math.floor(diffHours / 24);

  if (diffSecs < 45) return 'just now';
  if (diffMins < 60) return `${diffMins}m ago`;
  if (diffHours < 24) return `${diffHours}h ago`;
  if (diffDays === 1) return '1d ago';
  return `${diffDays}d ago`;
}

export function LastUpdatedBar({ polledAt, isHoliday }: Props) {
  const [, setTick] = useState(0);

  // Re-calculate relative time every 30 seconds
  useEffect(() => {
    const interval = setInterval(() => setTick((t) => t + 1), 30000);
    return () => clearInterval(interval);
  }, []);

  if (!polledAt) {
    return (
      <div className="last-updated">
        <span className="last-updated__dot last-updated__dot--idle" />
        <span>{isHoliday ? '🏛️ Court holiday' : 'Connecting…'}</span>
      </div>
    );
  }

  const fullDateTime = new Date(polledAt).toLocaleString('en-IN', {
    timeZone: 'Asia/Kolkata',
    dateStyle: 'medium',
    timeStyle: 'short',
  });

  return (
    <div className="last-updated" title={`Last polled: ${fullDateTime}`}>
      <span className="last-updated__dot" />
      <span>Updated {formatRelativeTime(polledAt)}</span>
    </div>
  );
}
